// extracted by mini-css-extract-plugin
module.exports = {"submenuLink":"Aside_submenuLink__3GUS8","aside":"Aside_aside__1kSgD"};